import { render, staticRenderFns } from "./AdditionalProductConsent.vue?vue&type=template&id=3c0ef0df&scoped=true&"
import script from "./AdditionalProductConsent.vue?vue&type=script&lang=js&"
export * from "./AdditionalProductConsent.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalProductConsent.vue?vue&type=style&index=0&id=3c0ef0df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ef0df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
